export const PlanIcon = () => (
    <svg
        fill="none"
        height="16"
        viewBox="0 0 16 16"
        width="16"
        xmlns="http://www.w3.org/2000/svg"
        aria-label="plan"
    >
        <path
            clipRule="evenodd"
            d="m8 1.5c-1.38071 0-2.5 1.11929-2.5 2.5v3h5v-3c0-1.38071-1.11929-2.5-2.5-2.5zm4 5.5v-3c0-2.20914-1.7909-4-4-4-2.20914 0-4 1.79086-4 4v3c-1.10457 0-2 .89543-2 2v5c0 1.1046.89543 2 2 2h8c1.1046 0 2-.8954 2-2v-5c0-1.10457-.8954-2-2-2zm-8 1.5c-.27614 0-.5.22386-.5.5v5c0 .2761.22386.5.5.5h8c.2761 0 .5-.2239.5-.5v-5c0-.27614-.2239-.5-.5-.5z"
            fill="#e06c00"
            fillRule="evenodd"
        />
    </svg>
);
